import React from "react";

// 12 radial bars, dark navy → light, so it reads as the classic fading "tail" spinner. The <svg> itself
// spins (see .switch-spinner in styles.css), which keeps it perfectly smooth.
const COLORS = [
  "#1e3a8a", "#1e46a3", "#1f52bd", "#2563eb", "#3b82f6", "#5296f7",
  "#6aa8f9", "#86bcfb", "#a3cefc", "#bfdcfe", "#d2e5fe", "#e6f0fe",
];

export function SwitchSpinner({ size = 54 }) {
  return (
    <svg className="switch-spinner" viewBox="0 0 100 100" width={size} height={size} aria-hidden="true">
      {COLORS.map((c, i) => (
        <rect key={i} x="45.5" y="7" width="9" height="23" rx="4.5"
          transform={`rotate(${i * 30} 50 50)`} fill={c} />
      ))}
    </svg>
  );
}